export default "__VITE_ASSET__29ac95fd__"